import React from 'react';

export const UserAvatar = ({ name, className = '' }) => {
    const getInitials = (name) => {
        if (!name) return '?';
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    const getRandomColor = (name) => {
        const colors = [
            '#506fd9', // primary blue
            '#33d685', // green
            '#0dcaf0', // cyan
            '#ea4c89', // pink
            '#6e7985', // gray
            '#1c96e9', // light blue
            '#fd7e14', // orange
        ];
        
        if (!name) return colors[0];
        const index = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
        return colors[index % colors.length];
    };

    const style = {
        backgroundColor: getRandomColor(name),
        color: '#fff',
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: '500'
    };

    return (
        <div className={`user-avatar ${className}`} style={style}>
            {getInitials(name)}
        </div>
    );
}; 